import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const TaxonomyLinked = React.lazy(
  () => import('components/Taxonomy/Linked/Linked'),
);

function ScreensTaxonomyLinked(params: Readonly<RoutePrivateProps>) {
  return (
    <BaseLayout>
      <DocumentTitle>Taxonomy Management</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <TaxonomyLinked
          id={parseInt(params.id as string, 10)}
          key={params.id}
        />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensTaxonomyLinked;
